import 'react-select/dist/react-select.css';
import 'react-virtualized/styles.css';
import 'react-virtualized-select/styles.css';

import React from 'react';
import * as R from 'ramda';
import Select from 'react-virtualized-select';

export default function MultiSelectInput(props) {
    const options = R.map(option => ({value: option.value, label: option.label}), props.options);
    const {key, value} = props.keyValue;
    return (
        <div className="row keyValueRow">
            <div className="col-sm-6">
                <Select
                    multi={props.multiSelect}
                    value={key}
                    options={options}
                    onChange={props.onChangeKey}
                />
            </div>
            <div className="col-sm-5">
                <input
                    value={R.isNil(value) ? '' : value}
                    className="form-control"
                    onChange={e => props.onChangeValue(e.target.value)}
                />
            </div>
            <div className="col-sm-1 removeItem">
                <span onClick={props.onRemoveKeyValue}>&#10006;</span>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./publisher_leads/advanced_filters/multi_select_group/multi_select_input.js